import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { TranslateService } from '@ngx-translate/core';
import { ValidationService } from './validation.service';
import { FormGroup } from '@angular/forms';



@Injectable({
  providedIn: 'root'
})
export class BaseService {
  public MaritalStatuses = new Array();
  public FamilyRelations = new Array();
  public ArmyServices = new Array();
  public Countries = new Array();
  public IsraelCities = new Array();
  public USA_States = new Array();  
  public taasuka = new Array();
  public megama = new Array();
  public IsraelyStatus = new Array({KOD: 1, TEUR: "ישראלי"}, {KOD: 2, TEUR: "עולה"}, {KOD: 3, TEUR: "תייר"}, {KOD: 4, TEUR: "אחר"});
  public ThumTaasuka = new Array();
  public Tchummikz   = new Array();
  public MezaheMishpaha;
  public LoggedUser = null;
  public LoggedUserPartner = null;
  public loginWay = true;
  public MEZAHE_ZAFUY_INTERNET = null;
  public errorsLoaded = new EventEmitter<any>();
  public errMessage = "";
  public invalidTabName = "";
  kodLatestGot = {getTchummikz: 0, getCities: 0};
  maxRecordsToGet = 100;
  

public hozrim = new Array(); 
  private ngUnsubscribe: any = new Subject();
  public exsist :any;
  
  url = "http://localhost:14414/api/";
  errors= new Array();

  constructor(private http: HttpClient, 
              configService: ConfigService,
              public translate:TranslateService
  ) {
    this.url = configService.getConfiguration().webApiUrl;
    this.maxRecordsToGet = configService.getConfiguration().recordsNumForPartualHttpGet;
    if (!this.maxRecordsToGet)
      this.maxRecordsToGet = 200;
    this.getData('getMazavMishpachti');
    this.getData('getSherutZvayi');
    this.getData('getCountries');
    this.getDataByPortions('getCities', this.IsraelCities);
    this.getData('getStates');
    // this.getData('getTaasuka');
    // this.getData('getMegama');
    // this.getData('getThumTaasuka');
    // this.getDataByPortions('getTchummikz', this.Tchummikz);
  }

  getErrosList() {
    this.translate.get('assistance-form.errors.DirectlyErr').subscribe((text: string) => { this.errors.push(text)  });
    this.translate.get('assistance-form.errors.invalidUidErr').subscribe((text: string) => { this.errors.push(text) });
    this.translate.get('assistance-form.errors.secondTimeErr').subscribe((text: string) => { this.errors.push(text) });
    this.translate.get('assistance-form.errors.istIsraelyErr').subscribe((text: string) => { this.errors.push(text) });
    this.translate.get('assistance-form.errors.dataErr').subscribe((text: string) => { this.errors.push(text) });
    this.translate.get('assistance-form.errors.notExsistUidErr').subscribe((text: string) => { 
      this.errors.push(text);
      this.errorsLoaded.emit();
    });
  }
  
  checkIsExistsID (ID) {
    let post_body = {id: ID};
    return this.http.post<string>(`${this.url}Continue`, post_body); 
  }

  checkLogin (ID, email, captcha) {
    return this.http.get(`${this.url}/isExists?fullID=${ID}&txtMail=${email}&&captcha=${captcha}`);
  }

  getFamily (ID, email) {
    return this.http.get(`${this.url}/getFamily?fullID=${ID}&txtMail=${email}`);
  }

  getListData(func: string) {
    return this.http.get(this.url + func);
    
  }

  getListDataParam(func: string, param: string) {
    return this.http.get(this.url + func + '?'+ param);
  }

  public SaveForm (form, captcha): Observable<string> {
    let post_body = {family: form, captcha: captcha};
    return this.http.post<string>(`${this.url}PostRegistration`, post_body); //, this.httpOptions)
  }
   httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
  }
  public SaveEmploymentForm (employmentForm): Observable<string> {
    return this.http.post<string>(`${this.url}/PostAssistance`, employmentForm,this.httpOptions); //, this.httpOptions)
  }

  public WriteErrorToDB (error): Observable<string> {
    return this.http.post<string>(`${this.url}/WriteErrorToDB`, error,this.httpOptions); //, this.httpOptions)
  }

  getDataByPortions (func_name, resultArray) {
    let param = `fromKod=${this.kodLatestGot[func_name]}&maxRecords=${this.maxRecordsToGet}`;
    this.getDataByPortionsPromise(func_name, param).then(
      (data: any) => { 
        this.pushData (func_name, resultArray, data);     
      })
      .catch((ex) => {
        console.log(ex);
      });
  }

  getDataByPortionsPromise(func_name, param): Promise<any> {
    return this.getListDataParam(func_name, param).toPromise();
  }

  pushData (func_name, resultArray, data) {
    if (data) {
      let data_arr = data as Array<any>;
      resultArray = resultArray.concat(data_arr);
      if (data_arr.length == this.maxRecordsToGet) {
        this.kodLatestGot[func_name] = data_arr[data_arr.length-1].KOD;
        this.getDataByPortions (func_name, resultArray) ;
        return;
      } 
    }
    switch (func_name)
    {
      case 'getCities':
        this.IsraelCities = resultArray; 
        break;

      case 'getTchummikz':
        this.Tchummikz = resultArray; 
      break;
    }
    this.kodLatestGot[func_name] = 0;    
  }

  getData(func_name) {
    this.getListData(func_name).subscribe(
      (data: any) => { 
        switch (func_name)
        {
          case 'getMazavMishpachti':
            this.MaritalStatuses = data; 
            break;

          case 'getSherutZvayi':
              this.ArmyServices = data; 
              break;
          case 'getCountries':
            this.Countries = data;
            break;
          case 'getCities':
          case 'getAllCities':
            this.IsraelCities = data;
            break;
          case 'getStates':
            this.USA_States = data;
            break;
          case 'getTaasuka':
            this.taasuka = data;
            break;
            case 'getMegama':
            this.megama = data;
            break;
          case 'getThumTaasuka':
          this.ThumTaasuka = data;
            break;
            case 'getTchummikz':
          this.Tchummikz = data;
            break;
          
        }
      },
      (err) => { console.log(func_name + ' error: ', err); }
    );
  }
  getMezaheMishpahaInternet() {
    return this.http.get(this.url + "MezaheMishpahaInternet")
  }

  public isPartnerReturning(f) {
    return f.marital_status == '2' && f.partner_returning == '1';
  }

  public isExistsSocialID_DuplicationsMessage (f, checkChildren = false) {
    this.errMessage = this.getSocialID_DuplicationsMessage (f, checkChildren);
    return (this.errMessage != "")
  }

  private getSocialID_DuplicationsMessage (f, checkChildren) {
    let tzs = [];
        tzs.push (f.value.form_HeadFamilyData.social_id);
        tzs.push (this.isPartnerReturning(f.value.form_HeadFamilyData) ? f.value.form_PartnerData.social_id : ""); 
        if (checkChildren) {
          let CData = f.value.form_ChildrenUp18Data.childrenItems;
          if (CData && CData.length > 0) {
            for (let i=0; i< CData.length; i++)
              tzs.push (CData[i].social_id);
          } else 
            tzs.push ("");
        }
    
        for(let i=0; i< tzs.length; i++) {
          for(let j=i+1; j< tzs.length; j++)
          {
            if ( tzs[i] && tzs[j] && (tzs[i] == tzs[j]))
            {
              let msg = "קיימת כפילות מספרי זהות של ";
              if (i==0) 
                msg += "ממלא הטופס ";
              else  {
                if (i==1)
                  msg += "בן/בת הזוג ";
                else {
                  msg += "ילדים";
                  return msg;
                }
              }
              
              if (j == 1) 
                msg += "ובן/בת הזוג";
              else 
                msg += "וילד";
    
              return msg;
            }
          }
        }
        return "";      
  }

  public clearMainErrorMessage() {
    this.errMessage = "";
    this.invalidTabName = "";
  }

  public isFormDatesValid (form, relation) {
    let retdt_control = form.controls.returning_date;
    let birthdt_control = form.controls.birth_date;
      
    retdt_control.setErrors(null);
    birthdt_control.setErrors(null);  

    let err = ValidationService.returningDatePassedValidator(retdt_control);
    if (err) {
      retdt_control.setErrors(err);
      return false;
    }        
   
    let err1 = ValidationService.returningDateToLateValidator(retdt_control, ((relation == 1) ? form.value.scientist : 
                                                                             (relation == 2) ? form.parent.value.form_HeadFamilyData.scientist :
                                                                              form.parent.parent.parent.value.form_HeadFamilyData.scientist) == "1");
    if (err1)
    {
      retdt_control.setErrors(err1);
      return false;
    }          
    
    if (relation == 1 || form.value.israely_status == '1') //israely
    {
      let err11 = ValidationService.didntPassed2YearsFromValidator(retdt_control, form.controls.departure_date);
      if (err11) {
        retdt_control.setErrors(err11);
        return false;
      }
    }

    if (relation == 1 || relation == 2) { // head of family or partner form
      let err2 = ValidationService.datesDiffernceLess17Years(retdt_control, form.controls.birth_date);
      if (err2) {
        form.controls.birth_date.setErrors(err2);
        return false;
      }       
    } 

    if (relation == 3) { // children form
      let err2 = ValidationService.datesDiffernceLess16Years(retdt_control, birthdt_control);
      if (err2) {
        birthdt_control.setErrors(err2); 
        return false;
      }        
      
      let err22 = ValidationService.datesDiffernceBigger18Years(retdt_control, birthdt_control);
      if (err22) {
        birthdt_control.setErrors(err22); 
        return false;      
      }        
    }     

    if (form.invalid) {
      form.markAllAsTouched();
      return false;
    }

    return true;  
  }

  isExists(uid) {
    return this.http.get(this.url + 'isExists?uid=' + uid);
  }

  getHozrim(param, MezaheMishpaha) {
    return this.http.get(this.url + 'getHozrim?MezaheMishpaha=' + MezaheMishpaha);
  }

  getPerson(Mezahe) {
    return this.http.get(this.url + 'getPerson?Mezahe=' + Mezahe);
  }

  setPartnerProperty (form)
  {
    if (form.value.form_HeadFamilyData && (form.value.form_HeadFamilyData.marital_status == 2) && 
      (form.value.form_HeadFamilyData.partner_returning == 1)
  )
      (form.controls.form_PartnerData as FormGroup).controls.sex.setValue(
          form.value.form_HeadFamilyData.sex == '1' ? '2' : '1');
  }
}